const LOADER = `<div class="loader">
  <div class="loader__inner"></div>
</div>`;

export function addLoader(el){
  removeLoader(el);
  $(el).append(LOADER);
}

window.addLoader = addLoader

export function removeLoader(el){
  $(el).find('.loader').remove();
}
